import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { SuccessCard } from '@identity/presentation/components/base';
import { PORTAL_ENTRY_ROUTE } from '@identity/presentation/constants';

/**
 * The last screen of the account verification flow.
 *
 * It deletes no credential: here the credential is the Parrot session, and clearing it would throw
 * the user out at the exact moment they earned their way back in.
 *
 * It exits to reports, which the route guard hands on to the first module this user can see when
 * reports is not one of them.
 */
export const VerificationDoneScreen = () => {
  const { t } = useTranslation('identity');
  const history = useHistory();

  return (
    <SuccessCard
      actionLabel={t('verifyAccount.done.action')}
      description={t('verifyAccount.done.body')}
      onAction={() => history.push(PORTAL_ENTRY_ROUTE)}
      title={t('verifyAccount.done.title')}
    />
  );
};
